import React from 'react'
import certified from "../../../images/speakers/certified.webp"
import zap from "../../../images/speakers/zap.webp"
import room from "../../../images/speakers/room.webp"
import program from "../../../images/speakers/program.webp"
import group from "../../../images/speakers/group.webp"


export default function Benefits() {
    return (
        <div className='bg-[#FFFFFF] w-11/12 mx-auto rounded-[14px] md:rounded-[44px] p-[25px] md:p-[50px] border border-[#007AFF26] mb-[50px] xl:mb-[70px] text-center' style={{ boxShadow: "0px 0px 25px -5px #00000033" }}>
            <h4 className='text-[#101828] font-semibold text-[22px] lg:text-[34px]'>Surge Speaker Benefits</h4>
            <div className='flex gap-[20px] md:gap-[50px] lg:gap-[80px] items-center justify-center mt-[20px] md:mt-[40px] flex-wrap'>
                <div>
                    <img src={certified} alt='certified' className='mx-auto w-[100px] md:w-[140px]' />
                    <p className='mt-[7px] md:mt-[14px] font-semibold text-[#101828] text-[14px] md:text-[20px]'>National Recognition Certificate</p>
                </div>
                <div>
                    <img src={zap} alt='zap' className='mx-auto w-[100px] md:w-[140px]' />
                    <p className='mt-[7px] md:mt-[14px] font-semibold text-[#101828] text-[14px] md:text-[20px]'>Surge Specialist Badge</p>
                </div>
                <div>
                    <img src={room} alt='room' className='mx-auto w-[100px] md:w-[140px]' />
                    <p className='mt-[7px] md:mt-[14px] font-semibold text-[#101828] text-[14px] md:text-[20px]'>Listed in the National Speaker Roll</p>
                </div>
                <div>
                    <img src={program} alt='program' className='mx-auto w-[100px] md:w-[140px]' />
                    <p className='mt-[7px] md:mt-[14px] font-semibold text-[#101828] text-[14px] md:text-[20px]'>Priority for college keynotes & events</p>
                </div>
                <div>
                    <img src={group} alt='group' className='mx-auto w-[100px] md:w-[140px]' />
                    <p className='mt-[7px] md:mt-[14px] font-semibold text-[#101828] text-[14px] md:text-[20px]'>Contribution to India’s youth transformation</p>
                </div>
            </div>
            <div className='mt-[20px] md:mt-[48px] w-full mx-auto bg-[#5856D61A] rounded-[10px] md:rounded-[20px] p-[12px] md:p-[24px] text-[#5856D6] font-medium'>
                <p className='font-bold text-[10px] md:text-[18px]'>But above all...</p>
                <p className='mt-[5px] md:mt-[10px] text-[14px] lg:text-[22px] font-normal'>A student telling you: <br/> Your one hour changed my life.</p>
                <p className='mt-[10px] md:mt-[20px] text-[12px] lg:text-[20px] font-semibold'>That’s the real reward.</p>
            </div>
        </div>
    )
}
